<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="给班级添加排课" v-model="hideShow" width="600px" persistent>
			<v-card>
				<v-card-title>
					<span>给班级添加排课</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense v-if="classModel">
						<v-col cols="12">
							<v-text-field label="班级名称" v-model="classModel.className" disabled dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6">
							<v-select :items="selectTeacherList" v-model="add.record.teacher" item-text="trueName"
								item-value="id" label="老师" dense outlined></v-select>
						</v-col>
						<v-col cols="6">
							<v-select :items="selectClassroomList" v-model="add.record.roomId" item-text="roomName"
								item-value="id" label="教室" dense outlined></v-select>
						</v-col>
						<v-col cols="6">
							<v-menu ref="menuclassDate" v-model="add.classDateMenu" :close-on-content-click="false"
								transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="add.record.classDate" label="开始上课日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="add.record.classDate" locale="zh-cn" 
									@input="add.classDateMenu=false" no-title scrollable></v-date-picker>								
							</v-menu>
						</v-col>
						<v-col cols="6">
							<v-text-field label="排课次数" type="number" v-model="add.record.lessonCount" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="4">
							<v-select v-model="add.record.weekAt" :items="weekItems" label="周几上课"
								item-text="weekName" item-value="week" outlined dense></v-select>
						</v-col>
						<v-col cols="3">
							<v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" :nudge-right="40"
								transition="scale-transition" offset-y
								max-width="290px" min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="add.record.timeFrom" label="上课时间"
										prepend-icon="mdi-clock-time-four-outline" dense readonly v-bind="attrs" v-on="on">
									</v-text-field>
								</template>
								<v-time-picker v-if="menu3" v-model="add.record.timeFrom" full-width format="24hr"
									@click:minute="saveTimeFrom(add.record.timeFrom)"></v-time-picker>
							</v-menu>
						</v-col>
						<v-col cols="2">
							<v-text-field label="时长(分钟)" type="number" v-model="add.record.timeMinutes" dense outlined @keyup="calItemTimeTo()">
							</v-text-field>
						</v-col>
						<v-col cols="3">
							<v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" :nudge-right="40"
								:return-value.sync="add.record.timeTo" transition="scale-transition" offset-y
								max-width="290px" min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="add.record.timeTo" label="下课时间"
										prepend-icon="mdi-clock-time-four-outline" dense readonly v-bind="attrs" v-on="on">
									</v-text-field>
								</template>
								<v-time-picker v-if="menu4" v-model="add.record.timeTo" full-width format="24hr"
									@click:minute="$refs.menu4.save(add.record.timeTo)"></v-time-picker>
							</v-menu>
						</v-col>
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitAddRecord" :disabled="add.submitting" :loading="add.submitting" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import global from "../config/global"
	import utils from "../config/utils"
	export default {
		name:"create-student",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			classId:{
				type:String,
				default:""
			}
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					
					this.add.record.classId = this.classId;
					
					this.getClassDetail();
					
					this.getClassroomListForSelect();
					this.getTeacherListForSelect();
				}
			}
		},
		data(){
			return {
				menu3:false,
				menu4:false,
				add: {
					dialog: false,
					classDateMenu:false,
					submitting:false,
					record: {
						classId: "",
						teacher: "",
						roomId:"",
						classDate:"",
						timeFrom:"",
						timeTo:"",
						timeMinutes:"45",
						weekAt:"",
						lessonCount:""
					},
				},
				classModel:null,
				weekItems:global.weekList,
				selectTeacherList:[],
				selectClassroomList:[],
				hideShow:this.show
			}
		},
		mounted() {
			console.log("create-student mounted");
		},
		methods:{
			calItemTimeTo(){
				// 选择开始时间 自动计算 结束时间
				
				
				// 必须有开始时间和时长
				if (!this.add.record.timeFrom || !this.add.record.timeMinutes){
					this.add.record.timeTo = "";
					console.log("no timeFrom or minutes");
					return
				}
				
				// 开始时间分割
				let arr = this.add.record.timeFrom.split(":");
				if (!arr || arr.length != 2){
					console.log("timeFrom invalid");
					return
				}
				// 构建一个日期 加上分钟数
				var sdate1 = new Date(2027,1,1,parseInt(arr[0]),parseInt(arr[1]),1);
				sdate1.setMinutes (sdate1.getMinutes () + parseInt(this.add.record.timeMinutes));
				
				// 新的时间和分钟
				let newHour = sdate1.getHours();
				let newMinutes = sdate1.getMinutes();
				
				// 左侧补齐2位
				const  hh = (Array(2).join(0) + newHour).slice(-2);
				const  mm = (Array(2).join(0) + newMinutes).slice(-2);
				
				var timeTo = hh+":"+mm;
				
				this.add.record.timeTo = timeTo;
				console.log("item.timeTo",timeTo);
				
			},
			saveTimeFrom(timefrom){
				this.add.record.timeFrom = timefrom;
				this.menu3 = false;
				this.calItemTimeTo();
			},
			cancel(){
				this.$emit("cancel","");
			},
			submitAddRecord() {
			
				if (!this.add.record.classDate) {
					this.$noty.error('上课日期不能为空');
					return
				}
				
				if (!this.add.record.roomId) {
					this.$noty.error('教室不能为空');
					return
				}
				if (!this.add.record.teacher) {
					this.$noty.error('老师不能为空');
					return
				}
				if (!this.add.record.timeFrom) {
					this.$noty.error('上课开始时刻不能为空');
					return
				}
				
				if (!this.add.record.timeTo) {
					this.$noty.error('上课结束时刻不能为空');
					return
				}
				
				if (!this.add.record.weekAt) {
					this.$noty.error('周几上课不能为空');
					return
				}
				
				if (!this.add.record.lessonCount) {
					this.$noty.error('排课次数不能为空');
					return
				}
				
				
				this.add.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/create`;
				let postData = {
					...this.add.record
				};
				postData.shopId = utils.getCurrentShopId();
				
			
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							
							that.add.submitting = false;
							that.$emit("success","");
							return;
						} else {
							that.add.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitting = false;
						that.$noty.error('网络请求失败');
					}
			
				});
			},
			getClassDetail(){
				console.log("获取班级详情");
				
				const that = this;
				let url = `/edu/class/detail/${this.classId}`;
				
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						
						console.log(">>>>>>>>> 获取班级基本信息 start>>>>>>>>>")
						
						console.log("url:",url);
						console.log("res:",response.data);
						
						console.log(">>>>>>>>> 获取班级基本信息 end>>>>>>>>>")
						
						that.classModel = response.data["data"] ? response.data["data"] : [];
						
						that.add.record.classId = that.classModel.id;
						that.add.record.teacher = that.classModel.teacher;
						that.add.record.roomId = that.classModel.roomId;
						
						
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				})
			},
			getTeacherListForSelect(){
				const shopId = utils.getCurrentShopId();
				if (!shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/teacher/list/`+shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getClassroomListForSelect(){
				const shopId = utils.getCurrentShopId();
				if (!shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/classroom/list/`+shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectClassroomList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
	
</script>

<style>
</style>
